import type { GetLabelsResponse } from '@vy/api-definition';
import { GetLabelsResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions, QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

async function labelsQuery() {
  const privateApi = getPrivateApi();
  const labels = await privateApi.getLabels();

  return GetLabelsResponseSchema.parse(labels);
}

export function useLabels(options?: UseQueryOptions<GetLabelsResponse>) {
  const queryKey = [queryKeys.labels()];
  const response = useQuery({
    queryKey,
    queryFn: labelsQuery,
    ...options,
  });

  return response;
}

export function prefetchLabels(queryClient: QueryClient) {
  return queryClient.prefetchQuery([queryKeys.labels()], labelsQuery);
}
